// Shared sport emoji utility
const getSportEmoji = (sportName) => {
  const emojiMap = {
    'Basketball': '🏀',
    'Volleyball': '🏐',
    'Tennis': '🎾',
    'Pickleball': '🏸',
    'Soccer': '⚽',
    'Badminton': '🏸',
    'Table Tennis': '🏓'
  };
  return emojiMap[sportName] || '🏆';
};

export default getSportEmoji;
